import { defineMessages } from 'react-intl-next';

export const messages: {
	moreButtonName: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	moreButtonName: {
		id: 'bulk-operations.platform-floating-toolbar.src.ui.show-more-button.more-button-name',
		defaultMessage: 'More actions',
		description:
			'Label for the more button in the bulk operations toolbar that contains more actions',
	},
});
